import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar";
import HomePage from "./modules/home";
import AOS from "aos";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";

const App = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      offset: 100, // Offset from the original trigger point
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
      <ToastContainer limit={2} />
    </Router>
  );
};

export default App;
